const SearchStatus = Object.freeze({
  INITIAL: "initial",
  LOADING: "loading",
  NO_RESULTS: "no_results",
  SHOW_RESULTS: "show_results",
});

export default SearchStatus;
